import { cn } from '@/lib/utils';
import Input, { type PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function PhoneInput({ inputClass, ...props }: PhoneInputProps) {
  return (
    <Input
      inputClass={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex w-full min-w-0 max-w-2xl rounded-md border bg-transparent px-3.5 py-2.5 text-sm shadow-xs transition-[color,box-shadow] duration-500 outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-accent md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-2',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        inputClass
      )}
      countryCodeEditable={props.countryCodeEditable ?? false}
      disableSearchIcon
      {...props}
    />
  );
}

export { PhoneInput };
